
<div mat-dialog-content class="flex flex-col">
  <span class="font-semibold pb-4">What is the name, date of birth, and contact information of the affected person?</span>
  <form class="pt-4" [formGroup]="affectedPersonForm">
    <div class="flex flex-col gap-4">
      <div class="flex flex-col md:flex-row gap-2 portal-field-grid">
        <mat-form-field class="md:w-1/3">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" #firstNameInput>
        </mat-form-field>

        <mat-form-field class="md:w-1/3">
          <mat-label>Middle Name</mat-label>
          <input matInput formControlName="middleName">
        </mat-form-field>

        <mat-form-field class="md:w-1/3">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName">
        </mat-form-field>
      </div>

      <div class="flex flex-col md:flex-row gap-2 portal-field-grid">
        <mat-form-field class="md:w-1/3">
          <mat-label>Phone</mat-label>
          <input matInput formControlName="phone" mask="000-000-0000">
        </mat-form-field>

        <mat-form-field class="md:w-2/3">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email">
            <mat-error *ngIf="affectedPersonForm.get('email').invalid">
              Email is invalid
            </mat-error>
        </mat-form-field>
      </div>

      <mat-form-field class="md:w-2/3 portal-full-panel">
        <mat-label>Address</mat-label>
        <textarea matInput placeholder="Address, City, State & Zip" type="text" rows="1" formControlName="address"></textarea>
      </mat-form-field>

      <div class="flex flex-col md:flex-row gap-2 portal-field-grid">
        <mat-form-field class="md:w-1/3">
          <mat-label>Date of Birth</mat-label>
          <input placeholder="mm/dd/yyyy" matInput [matDatepicker]="dobPicker" formControlName="dob">
          <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
          <mat-datepicker #dobPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="md:w-1/3">
          <mat-label>Gender</mat-label>
          <input matInput formControlName="gender">
        </mat-form-field>
      </div>

      <div class="flex flex-col">
        <span class="font-semibold pb-4">What is your relationship to the patient/client?</span>
        <mat-form-field class="md:w-1/3 portal-full-panel">
          <mat-label>Relationship:</mat-label>
          <mat-select formControlName="relationship">
            <mat-option value="Current Staff">Current Staff</mat-option>
            <mat-option value="Former Staff">Former Staff</mat-option>
            <mat-option value="Anonymous">Anonymous</mat-option>
            <mat-option value="Family">Family</mat-option>
            <mat-option value="Friend">Friend</mat-option>
            <mat-option value="Ombudsman">Ombudsman</mat-option>
            <mat-option value="OR APS">OR APS</mat-option>
            <mat-option value="OR DHS">OR DHS</mat-option>
            <mat-option value="Other State Agency">Other State Agency</mat-option>
            <mat-option value="Federal Agency">Federal Agency</mat-option>
            <mat-option value="Other licensed IHC Agency">Other licensed IHC Agency</mat-option>
            <mat-option value="Other Health Care Provider">Other Health Care Provider</mat-option>
            <mat-option value="Physician">Physician</mat-option>
            <mat-option value="Coroner">Coroner</mat-option>
            <mat-option value="Media">Media</mat-option>
            <mat-option value="Other">Other</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="flex flex-col" *ngIf="relationShipExtraDetails(affectedPersonForm.get('relationship').value)">
          <span class="font-semibold pb-4">Please provide the agency, outlet, etc. For current staff please provide your date of hire.
            For former staff please provide the dates of employment.</span>
          <mat-form-field class="md:w-2/3 portal-full-panel">
            <mat-label>Details</mat-label>
            <input matInput formControlName="relationshipOther">
          </mat-form-field>
        </div>
      </div>

      <div class="flex flex-col gap-2 align-middle">
        <div class="flex flex-col gap-2">
          <label id="canContact" class="font-semibold">
            Can we contact the client for additional information?
          </label>
          <mat-radio-group aria-labelledby="canContact" formControlName="canContact">
            <mat-radio-button [value]="true">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]="false">
              No
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="flex flex-col" *ngIf="affectedPersonForm.get('canContact').value === false">
          <span class="font-semibold pb-4">If no, please specify why not:</span>
          <mat-form-field>
            <mat-label>Reason:</mat-label>
            <mat-select formControlName="whyNoContact">
              <mat-option value="Client is deceased">Client is deceased</mat-option>
              <mat-option value="Client is unable">Client is unable</mat-option>
              <mat-option value="Client is unwilling">Client is unwilling</mat-option>
              <mat-option value="Client wants to remain anonymous">Client wants to remain anonymous</mat-option>
              <mat-option value="Other">-- Other --</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field *ngIf="affectedPersonForm.get('whyNoContact').value === 'Other'">
          <mat-label>Other Reason</mat-label>
          <input matInput formControlName="otherContactReason">
        </mat-form-field>
      </div>

      <span class="font-semibold">If the client was in a facility, in what department, or on what unit or floor did the incident(s) occur?</span>
      <mat-form-field>
        <textarea matInput placeholder="Incident Location" type="text" rows="5" formControlName="incidentLocation"></textarea>
      </mat-form-field>

      <span class="font-semibold pb-4">What date was the client admitted to the facility/agency?</span>
      <mat-form-field class="md:w-1/3 portal-full-panel">
        <mat-label>Date Admitted</mat-label>
        <input matInput [matDatepicker]="admittedPicker" formControlName="dateAdmitted">
        <mat-datepicker-toggle matSuffix [for]="admittedPicker"></mat-datepicker-toggle>
        <mat-datepicker #admittedPicker></mat-datepicker>
      </mat-form-field>

      <div class="flex flex-col gap-2 md:w-2/3 portal-full-panel">
        <label id="currentPatient" class="font-semibold">
          Is the client still in the facility or still receiving agency services?
        </label>
        <mat-radio-group aria-labelledby="currentPatient" formControlName="currentPatient">
          <mat-radio-button [value]="true">
            Yes
          </mat-radio-button>
          <mat-radio-button [value]="false">
            No
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="flex flex-col" *ngIf="affectedPersonForm.get('currentPatient').value === false">
        <span class="font-semibold pb-4">What date was the client discharged from the facility or stopped receiving agency services?</span>
        <mat-form-field class="md:w-1/3 portal-full-panel" >
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="dischargedPicker" formControlName="dateDischarged">
          <mat-datepicker-toggle matSuffix [for]="dischargedPicker"></mat-datepicker-toggle>
          <mat-datepicker #dischargedPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <span class="font-semibold">What services did the client receive?</span>
      <mat-form-field>
        <textarea matInput placeholder="Services Received" type="text" rows="5" formControlName="servicesReceived"></textarea>
      </mat-form-field>

      <span class="font-semibold">What was the client's schedule (days per week, hours per day)?</span>
      <mat-form-field>
        <textarea matInput placeholder="Client Schedule" type="text" rows="3" formControlName="clientSchedule"></textarea>
      </mat-form-field>

    </div>
  </form>
  <div mat-dialog-actions align="end" class="pt-4">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="savePerson()" [disabled]="affectedPersonForm.invalid">Save</button>
  </div>
</div>
